import React from "react";
import { Container, List, ListItem, Typography } from "@material-ui/core";

const Welcome = () => {
  return (
    <Container maxWidth="xl" style={{ minHeight: "90vh", paddingTop: "3em" }}>
      <Typography variant="h4" gutterBottom>
        Bienvenido
      </Typography>
      <Typography variant="body1">
        Este es el Sistema de Gestión de Investigación perteneciente a la
        ESPOCH, cuyos usuarios serán los responsables de gestionar la
        información de:
      </Typography>
      <List>
        <ListItem>- Grupos de Investigación</ListItem>
        <ListItem>- Proyectos de Investigación</ListItem>
      </List>
      <div variant="body1" style={{ alignSelf: "flex-end" }}>
        <div>
          Puedes enviar un mensaje&nbsp;
          <a href="mail: raquel.zabala@espoch.edu.ec"> al administrador</a>
          &nbsp; en caso de alguna incidencia.
        </div>
      </div>
    </Container>
  );
};

export default Welcome;
